<template>
  <div class="category-section">
    <v-list-item @click="$emit('toggle')" class="category-header">
      <v-list-item-icon class="mr-2">
        <v-icon small color="#023449">
          {{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="category-title">{{ title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-expand-transition>
      <div v-show="expanded">
        <slot></slot>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'DateCategory',
  props: {
    title: String,
    expanded: Boolean
  }
};
</script>

<style scoped>
.category-section {
  background: #ffffff;
}

.category-header {
  background: #f9fafb !important;
  cursor: pointer;
  min-height: 48px !important;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f3f4f6;
}

.category-header:hover {
  background: #f3f4f6 !important;
}

.category-header >>> .v-list-item__icon {
  margin-right: 12px !important;
  min-width: 28px !important;
}

.category-title {
  font-size: 0.875rem !important;
  font-weight: 700 !important;
  color: #023449 !important;
  letter-spacing: 0.02em;
}
</style>
